<input 
  [class]="class" 
  type="file" 
  (change)="setFile($event)" 
  [value]="value"
  [id]="$id"
  [disabled]="disabled"
  #file
>